export default "/react/logoSmartbot-4f3e6abe.png";